import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class OrderPaymentPlanDetail extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, eventId, id }) {
        if (!organizationId || !eventId || !id) {
            throw new ArgumentError('[Model][OrderPaymentPlanDetail] organizationId, eventId and orderId are mandatory');
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/orders/${id}/payment_plan_detail`;
    }

    static getItemUrl(params) {
        if (!params.id) {
            throw new ArgumentError(`[Model]OrderPaymentPlanDetail] id is mandatory`);
        }

        return this.getListUrl(params);
    }
}
